export const profileinfoConstants = {

    PROFILE_GETALLINFO_REQUEST: 'PROFILE_INFO_GETALL_REQUEST',
    PROFILE_GETALLINFO_SUCCESS: 'PROFILE_INFO_GETALL_SUCCESS',
    PROFILE_GETALLINFO_FAILURE: 'PROFILE_INFO_GETALL_FAILURE',
    DECREASE_SPARKS_COUNT: "DECREASE_SPARKS_COUNT",
    CHANGE_TOTAL_LIKES_COUNT: "CHANGE_TOTAL_LIKES_COUNT",
};
